import { render, staticRenderFns } from "./ResponseDescText.vue?vue&type=template&id=1a8482b2&scoped=true"
import script from "./ResponseDescText.vue?vue&type=script&lang=js"
export * from "./ResponseDescText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8482b2",
  null
  
)

export default component.exports